import { observer } from 'mobx-react-lite';
import {
    Box, Typography, Paper, CircularProgress,
    Table, TableHead, TableRow, TableCell, TableBody
} from '@mui/material';
import searchStore from '../../Mobx/SearchStore';

// זיהוי כיוון טקסט לפי שפה
const getDirection = (text) => {
    return /[\u0590-\u05FF]/.test(text) ? 'ltr' : 'rtl';
};

// קומפוננטה לתא עם כיוון טקסט אוטומטי
const DirectionAwareCell = ({ children }) => {
    const text = typeof children === 'string' ? children : '';
    const dir = getDirection(text);
    return (
        <TableCell sx={{ direction: dir, textAlign: dir === 'rtl' ? 'right' : 'left' }}>
            {children}
        </TableCell>
    );
};

// רינדור טקסט עם הדגשות (highlight)
const renderHighlightedText = (item) => {
    const highlight = item.highlights?.[0];
    if (!highlight || !highlight.texts?.length) {
        return item.originalWithoutPunctuation;
    }

    return highlight.texts.map((t, i) =>
        t.type === 'hit' ? (
            <strong key={i}>{t.value}</strong>
        ) : (
            <span key={i}>{t.value}</span>
        )
    );
};

const SearchResults = observer(() => {
    if (searchStore.loading)
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress sx={{ color: 'white' }} />
            </Box>
        );

    return (
        <Paper sx={{ p: 0, display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
            {/* <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                תוצאות
            </Typography> */}

            <Box sx={{ overflow: 'auto', flex: 1, minHeight: 0 }}>
                {searchStore.results.length === 0 ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                fontStyle: 'italic',
                            }}
                        >
                            אין תוצאות
                        </Typography>
                    </Box>
                ) : (
                    <Table
                        size="small"
                        sx={{
                            borderCollapse: 'separate',
                            borderSpacing: 0,
                            '& th, & td': {
                                borderBottom: '1px solid #eee',
                            },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    sx={{
                                        fontWeight: 'bold',
                                        color: 'white',
                                        backgroundColor: '#424242',
                                        textAlign: 'center',
                                        width: '30px',
                                        borderTopLeftRadius: '4px',
                                        borderBottom: '1px solid #555',
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 1,
                                    }}
                                >
                                    #
                                </TableCell>
                                {['original Without Punctuation', 'original', 'trns', 'pos', 'band', 'score'].map(
                                    (label, i, arr) => (
                                        <TableCell
                                            key={label}
                                            sx={{
                                                fontWeight: 'bold',
                                                color: 'white',
                                                backgroundColor: '#424242',
                                                direction: 'rtl',
                                                textAlign: 'center', // יישור למרכז בכותרת
                                                borderBottom: '1px solid #555',
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 1,
                                                ...(i === arr.length - 1 && { borderTopRightRadius: '4px' }),
                                            }}
                                        >
                                            {label}
                                        </TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {searchStore.results.map((item, idx) => (
                                <TableRow key={idx}>
                                    <TableCell sx={{ textAlign: 'center' }}>{idx + 1}</TableCell>
                                    <TableCell
                                        sx={{
                                            direction: getDirection(item.originalWithoutPunctuation),
                                            textAlign:
                                                getDirection(item.originalWithoutPunctuation) === 'rtl'
                                                    ? 'right'
                                                    : 'left',
                                        }}
                                    >
                                        {renderHighlightedText(item)}
                                    </TableCell>
                                    <DirectionAwareCell>{item.original || ''}</DirectionAwareCell>
                                    <DirectionAwareCell>{item.trns || ''}</DirectionAwareCell>
                                    <DirectionAwareCell>{item.pos || ''}</DirectionAwareCell>
                                    <DirectionAwareCell>{item.band || ''}</DirectionAwareCell>
                                    <DirectionAwareCell>
                                        {item.score != null ? item.score.toFixed(3) : ''}
                                    </DirectionAwareCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </Box>
        </Paper>
    );
});

export default SearchResults;
